import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import { ReactNode } from "react";
import { VehicleCheckStatus } from "../../models/VehicleCheck";
import { AUDIT_TOKENS } from "../../theme/auditTokens";

export type PillTone = VehicleCheckStatus | "digital" | "analog";

const TONES: Record<PillTone, { color: string; background: string; border?: string; weight: number }> = {
  digital: { color: AUDIT_TOKENS.ok.fg, background: AUDIT_TOKENS.ok.bg, weight: 600 },
  analog: { color: AUDIT_TOKENS.warn.fg, background: AUDIT_TOKENS.warn.bg, weight: 600 },
  ok: { color: AUDIT_TOKENS.ok.fg, background: AUDIT_TOKENS.ok.bg, weight: 600 },
  warn: { color: AUDIT_TOKENS.warn.fg, background: AUDIT_TOKENS.warn.bg, weight: 600 },
  alert: { color: AUDIT_TOKENS.alert.fg, background: AUDIT_TOKENS.alert.bg, weight: 600 },
  offen: {
    color: AUDIT_TOKENS.none.fg,
    background: AUDIT_TOKENS.none.bg,
    border: `1px dashed ${AUDIT_TOKENS.dashed}`,
    weight: 500,
  },
  neutral: { color: AUDIT_TOKENS.text, background: AUDIT_TOKENS.none.bg, weight: 500 },
};

const Pill = styled("span", { shouldForwardProp: prop => prop !== "tone" })<{
  tone: PillTone;
}>(({ tone }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "3px 10px",
  borderRadius: 999,
  fontSize: 12.5,
  lineHeight: 1.3,
  whiteSpace: "nowrap",
  fontWeight: TONES[tone].weight,
  color: TONES[tone].color,
  background: TONES[tone].background,
  border: TONES[tone].border,
}));

interface Props {
  tone: PillTone;
  children: ReactNode;
  title?: string;
}

/** `.hv-pill` from the reference stylesheet. */
export function StatusPill({ tone, children, title }: Props) {
  const pill = (
    <Pill tone={tone} aria-label={title}>
      {children}
    </Pill>
  );
  return title ? <Tooltip title={title}>{pill}</Tooltip> : pill;
}
